import React from 'react';
import { FontSize } from '@common/tokens';

export const SearchResultRowSubcontent = (props: {
  children?: React.ReactNode;
}) => (
  <>
    <span className="SearchResultRowSubcontent">{props.children}</span>
    <style jsx>{`
      .SearchResultRowSubcontent {
        font-size: ${FontSize.xs};
      }
    `}</style>
  </>
);
